import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useState } from "react";

const CreateProduct = () => {
  const [formData, setFormData] = useState({
    productName: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const CreateStore = () => {
    setFormData(formData);
    console.log("Create Product", formData);
  };
  return (
     <Box sx={{ width: "100%", height: "100vh",overflow:'auto' }}>
           <Box  sx={{
             width: "1143px",
             mt: { xs: 10, md: 10 },
           }}>
      <Card sx={{ p: 2, mx: "auto", borderRadius: "16px" }} elevation={2}>
        <Typography fontWeight={700} fontSize={24} m={2} fontFamily={"Aeonik"}>
          Create New Product
        </Typography>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              {/* Product nametextfield */}
              <TextField
                fullWidth
                label="Product Name"
                size="small"
                placeholder="Product name"
                sx={{
                  width: "100%", // ensures full width
                  minWidth: { xs: "210px", sm: "332px" }, // optional
                }}
                name="productName"
                value={formData.productName}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              {/* Metal nametextfield  */}
              <TextField
                fullWidth
                label="Metal Name"
                size="small"
                placeholder="Metal name"
                sx={{
                  width: "100%", // ensures full width
                  minWidth: { xs: "210px", sm: "332px" }, // optional
                }}
                name="metalName"
                value={formData.metalName}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              {/* Karat Dropdownlist */}
              <FormControl
                fullWidth
                size="small"
                sx={{
                  width: "100%", // ensures full width
                  minWidth: { xs: "210px", sm: "332px" }, // optional
                }}
              >
                <InputLabel>Karat</InputLabel>
                <Select
                  label="Karat"
                  name="karat"
                  value={formData.karat}
                  onChange={handleChange}
                >
                  <MenuItem value={18}>18K</MenuItem>
                  <MenuItem value={22}>22K</MenuItem>
                  <MenuItem value={24}>24K</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4}>
              {/* Rate per gram dropdownlist */}
              <FormControl
                fullWidth
                size="small"
                sx={{
                  width: "100%", // ensures full width
                  minWidth: { xs: "210px", sm: "332px" }, // optional
                }}
              >
                <InputLabel>Rate Per Gram</InputLabel>
                <Select label="Rate Per Gram">
                  <MenuItem value={18}>18K</MenuItem>
                  <MenuItem value={22}>22K</MenuItem>
                  <MenuItem value={24}>24K</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4}>
              {/* Purity textfield */}
              <TextField
                fullWidth
                label="Purity"
                size="small"
                placeholder="Enter purity"
                sx={{
                  width: "100%", // ensures full width
                  minWidth: { xs: "210px", sm: "332px" }, // optional
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              {/* Weights textfield */}
              <TextField
                fullWidth
                label="Weight(gms)"
                size="small"
                placeholder="Enter Weight"
                sx={{
                  width: "100%", // ensures full width
                  minWidth: { xs: "210px", sm: "332px" }, // optional
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              {/* Metal cost textfield */}
              <TextField
                fullWidth
                label="Metal Cost"
                size="small"
                placeholder="Enter metal cost"
                sx={{
                  width: "100%", // ensures full width
                  minWidth: { xs: "210px", sm: "332px" }, // optional
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              {/* Percentage based charges checkbox */}
              <FormControlLabel
                control={<Checkbox />}
                label="Percentage-Based Charges?"
                sx={{ color: "#606778" }}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <Card
        sx={{ p: 2, mx: "auto", mt: 4, borderRadius: "16px" }}
        elevation={2}
      >
        <Typography fontWeight={700} fontSize={24} m={2} fontFamily={"Aeonik"}>
          {" "}
          Making Charges
        </Typography>
        <CardContent>
          <Grid container spacing={2}>
            {/* <Grid container spacing={2}> */}
            <Grid item xs={12} md={4}>
              {/* Making Charges textfield */}
              <TextField
                fullWidth
                label="Making Charges"
                size="small"
                placeholder="Enter making charges"
                sx={{
                  width: "100%", // ensures full width
                  minWidth: { xs: "210px", sm: "332px" }, // optional
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              {/* Discount on making textfield */}
              <TextField
                fullWidth
                label="Discount on Making (%)"
                size="small"
                placeholder="Enter discount on making "
                sx={{
                  width: "100%", // ensures full width
                  minWidth: { xs: "210px", sm: "332px" }, // optional
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              {/* gst o making Textfield */}
              <TextField
                fullWidth
                label="GST on Making (%)"
                size="small"
                placeholder="Enter Gst on making"
                sx={{
                  width: "100%", // ensures full width
                  minWidth: { xs: "210px", sm: "332px" }, // optional
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              {/* Final making charges texfield */}
              <TextField
                fullWidth
                label="Final Making Charges"
                size="small"
                placeholder="Enter final making charges "
                sx={{
                  width: "100%", // ensures full width
                  minWidth: { xs: "210px", sm: "332px" }, // optional
                }}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <Card
        sx={{ p: 2, mx: "auto", mt: 4, borderRadius: "16px" }}
        elevation={2}
      >
        <Typography fontWeight={700} fontSize={24} m={2} fontFamily={"Aeonik"}>
          {" "}
          Delivery Charges
        </Typography>
        <CardContent>
          <Grid container spacing={2}>
            {/* <Grid container spacing={2}> */}
            <Grid item xs={12} md={4}>
              {/* Deliver charges textfield */}
              <TextField
                fullWidth
                label="Delivery Charges"
                size="small"
                placeholder="Enter delivery charges"
                sx={{
                  width: "100%", // ensures full width
                  minWidth: { xs: "210px", sm: "332px" }, // optional
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              {/* discount on delivery charges */}
              <TextField
                fullWidth
                label="Discount on Delivery (%)"
                size="small"
                placeholder="Enter discount on delivery"
                sx={{
                  width: "100%", // ensures full width
                  minWidth: { xs: "210px", sm: "332px" }, // optional
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              {/* Gst ondelivery Textfield */}
              <TextField
                fullWidth
                label="GST on Delivery (%)"
                size="small"
                placeholder="Enter gst on delivery"
                sx={{
                  width: "100%", // ensures full width
                  minWidth: { xs: "210px", sm: "332px" }, // optional
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              {/* Final Delivery Charges textfield */}
              <TextField
                fullWidth
                label="Final Delivery Charges"
                size="small"
                placeholder="Enter final delivery charges"
                sx={{
                  width: "100%", // ensures full width
                  minWidth: { xs: "210px", sm: "332px" }, // optional
                }}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <Card
        sx={{ p: 2, mx: "auto", mt: 4, borderRadius: "16px" }}
        elevation={2}
      >
        <Typography fontWeight={700} fontSize={24} m={2} fontFamily={"Aeonik"}>
          {" "}
          Packing Charges
        </Typography>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              {/* Packing Charges textfield */}
              <TextField
                fullWidth
                label="Packing Charges"
                size="small"
                placeholder="Enter packing charges"
                sx={{
                  width: "100%", // ensures full width
                  minWidth: { xs: "210px", sm: "332px" }, // optional
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              {/* Discount on packing textfield */}
              <TextField
                fullWidth
                label="Discount on Packing (%)"
                size="small"
                placeholder="Enter discount on packing"
                sx={{
                  width: "100%", // ensures full width
                  minWidth: { xs: "210px", sm: "332px" }, // optional
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              {/* Gst on packing Textfield */}
              <TextField
                fullWidth
                label="GST on Packing (%)"
                size="small"
                placeholder="Enter Gst on packing"
                sx={{
                  width: "100%", // ensures full width
                  minWidth: { xs: "210px", sm: "332px" }, // optional
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              {/* Final packing charges textfield */}
              <TextField
                fullWidth
                label="Final Packing Charges"
                size="small"
                placeholder="Enter final packing charges"
                sx={{
                  width: "100%", // ensures full width
                  minWidth: { xs: "210px", sm: "332px" }, // optional
                }}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <Card
        sx={{ p: 2, mx: "auto", mt: 4, borderRadius: "16px" }}
        elevation={2}
      >
        <Typography fontWeight={700} fontSize={24} m={2} fontFamily={"Aeonik"}>
          {" "}
          Product Cost
        </Typography>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              {/* Discount on product textfield */}
              <TextField
                fullWidth
                label="Discount on Product (%)"
                size="small"
                placeholder="Enter discount on packing"
                sx={{
                  width: "100%", // ensures full width
                  minWidth: { xs: "210px", sm: "332px" }, // optional
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              {/* tax textfield */}
              <TextField
                fullWidth
                label="Tax (%)"
                size="small"
                placeholder="Enter Tax"
                sx={{
                  width: "100%", // ensures full width
                  minWidth: { xs: "210px", sm: "332px" }, // optional
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Description"
                size="small"
                placeholder="Enter description"
                sx={{
                  width: "100%", // ensures full width
                  minWidth: { xs: "210px", sm: "332px" }, // optional
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              {/* Final product charges textfield */}
              <TextField
                fullWidth
                label="Final Product Charges"
                size="small"
                placeholder="Enter final product charges"
                sx={{
                  width: "100%", // ensures full width
                  minWidth: { xs: "210px", sm: "332px" }, // optional
                }}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <Card
        sx={{
          p: 3,
          maxWidth: 1200,
          mx: "auto",
          mt: 4,
          mb: 4,
          borderRadius: "16px",
        }}
      >
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              {/* Tags Textfield  */}
              <TextField
                fullWidth
                label="Tags (optional) :"
                size="small"
                placeholder="Enter Tags"
                sx={{
                  width: "100%", // ensures full width
                  minWidth: { xs: "210px", sm: "332px" }, // optional
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              {/* choose file button and textfield */}
              <TextField
                type="file"
                size="small"
                sx={{
                  width: "100%", // ensures full width
                  minWidth: { xs: "210px", sm: "332px" }, // optional
                }}
                fullWidth
                label="Upload File"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CloudUploadIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={3}>
            <Grid item xs={12}>
              {/* Add button  */}
              <Button
                variant="contained"
                sx={{ bgcolor: "#752ADA", textTransform: "none", px: 2 }}
              >
                + Add
              </Button>{" "}
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <Box mb={8} display="flex" justifyContent="flex-end">
        {/* Save button */}
        <Button
          variant="contained"
          sx={{ backgroundColor: "#752ADA", px: 6, textTransform: "none" }}
          onClick={CreateStore}
        >
          Save
        </Button>
      </Box>
    </Box>
    </Box>
  );
};

export default CreateProduct;
